import React from "react";
import CountUp from "react-countup";
import "./Increament.scss";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { FaUserGraduate, FaHandshake } from "react-icons/fa";
import { MdThumbUp } from "react-icons/md";

const stats = [
  {
    id: 1,
    icon: <FaUserGraduate />,
    end: 300,
    suffix: "+",
    label: "Professionals Trained",
  },
  {
    id: 2,
    icon: <MdThumbUp />,
    end: 98,
    suffix: "%",
    label: "Client Satisfaction",
  },
  {
    id: 3,
    icon: <FaHandshake />,
    end: 50,
    suffix: "+",
    label: "Corporate Partners",
  },
  {
    id: 4,
    icon: <AiOutlineFundProjectionScreen />,
    end: 75,
    suffix: "+",
    label: "Successful Projects",
  },
];

const Increament = () => {
  return (
    <section className="increament-section">
      <div className="section-header">
        <h2>Our Growth in Numbers</h2>
        <p>
          We measure our success through results — delivering impactful projects,
          empowering professionals, and exceeding client expectations.
        </p>
      </div>

      <div className="increament-grid">
        {stats.map((item) => (
          <div className="increament-card" key={item.id}>
            <div className="icon">{item.icon}</div>
            <div className="count">
              <CountUp
                start={0}
                end={item.end}
                duration={2.5}
                enableScrollSpy={true}
                suffix={item.suffix}
              />
            </div>
            <h3>{item.label}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Increament;
